import { SysState } from "./types";
import { indexedDBSettings } from "@/const/indexedDB";
const sysState: SysState = {
  sysInfo: [],
  indexedDB: null,
  version: {
    gameVersion: "0.0.3",
    dbVersion: indexedDBSettings.version
  },
  ws: undefined,
  onlinePlayers: [],
  wsId: 0
};

export default sysState;
